import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../services/base-component.service';

@Component({
  selector: 'gpa-liq-pagamento',
  templateUrl: './liq-pagamento.component.html',
  providers: [BaseComponentService],
  styles: [
    `
      .fieldRow {
      height:1px; border:none; color:#000; background-color:#000; margin-top: 0px; margin-bottom: 0px;'
      }
  `
  ]
})

export class LiqPagamentoComponent extends BaseComponentService implements OnInit {

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-pagamento.component.ts